import { useEffect, useState, useMemo, useRef } from 'react';
import globalTranslationManager from './translation_manager';
import _ from 'lodash';
import './LocalTranslatedText.scss';
import Tooltip from '@mui/material/Tooltip';
import { useTranslationContext } from './TranslationProvider';

function trimSymbolsAndWhitespace(text) {
  const result = /^[\s\W]*(.*?)[\s\W]*$/.exec(text);
  return result === null ? text : result[1];
}

export default function LocalTranslatedText({
  text,
  showOptionToViewOriginalLanguage,
}) {
  const [translated, setTranslated] = useState(null);
  const spanRef = useRef(null);
  const { showTranslation, language } = useTranslationContext();

  useEffect(() => {
    if (_.isString(text) && showTranslation && language !== 'en') {
      globalTranslationManager
        .fetchTranslation(text, language)
        .then((translation) => {
          setTranslated(translation);
        });
    }
  }, [text, language, showTranslation]);

  const textWithTranslation = useMemo(() => {
    if (!_.isString(text)) return text;

    if (translated) {
      const trimmedTranslated = trimSymbolsAndWhitespace(translated);
      const trimmedText = trimSymbolsAndWhitespace(text);
      return `${trimmedTranslated} - ${trimmedText}`;
    } else {
      return text;
    }
  }, [text, translated]);

  if (!_.isString(text)) return text;

  if (showTranslation && translated && translated !== text) {
    if (showOptionToViewOriginalLanguage) {
      return (
        <Tooltip
          title={`Original: ${text}`}
          placement="top-start"
          classes={{ tooltip: 'local-translated-text-original-text-tooltip' }}
          leaveDelay={500}
        >
          <span className="local-translated-text-with-original" ref={spanRef}>
            {translated}
          </span>
        </Tooltip>
      );
    } else {
      return (
        <span
          className="local-translated-text-without-original"
          title={textWithTranslation}
        >
          {translated}
        </span>
      );
    }
  }

  return <span className="local-translated-text-without-original">{text}</span>;
}
